import styled from "styled-components";
import {
  PurchaseLinkPriceOption,
  PurchaseVariantSelectionType,
} from "../enums";
import { CustomLabel, IOption } from "@mindmemobile/mm-shared-global";
import { CustomCarouselWrapper } from "../components/CarouselComponent";

export const priceOptions = [
  {
    label: "Specific prices",
    value: PurchaseLinkPriceOption.Specific,
  } as IOption,
  {
    label: "All active prices",
    value: PurchaseLinkPriceOption.AllActive,
  } as IOption,
];

export const getVariantOptions = (isTrackInventory: boolean) => {
  const variantOptions = [
    {
      label: "Specific variants",
      value: PurchaseVariantSelectionType.SpecificVariants,
    } as IOption,
    {
      label: "All available variants",
      value: PurchaseVariantSelectionType.AllActiveVariants,
    } as IOption,
  ];

  if (isTrackInventory) {
    variantOptions.push({
      label: "All available variants with inventory",
      value: PurchaseVariantSelectionType.AllActiveVariantsWithInventory,
    } as IOption);
  }

  return variantOptions;
};

export const PurchaseLinkPopupWrapper = styled.div`
  /* pl- stands for Purchase Link */
  .pl-header {
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    display: inline-block;
    margin-bottom: 20px;
  }
  .pl-input-labels {
    ${CustomLabel} {
      font-weight: 400;
      line-height: 18px;
      margin-bottom: 10px;
      &.pl-no-margin {
        margin-bottom: 0px;
      }
    }
    .styled-input.merchant-inputs {
      width: 300px;
    }
  }
  .label-description-row {
    margin-bottom: 30px;
  }
  .pl-chkbx-panel {
    margin-top: 40px;

    > label {
      font-weight: 600;
      font-size: 18px;
      & + i {
        margin-top: 2px;
        margin-left: 10px;
      }
    }
  }
  /* Two options per row, each taking half the width so every row lines up on
     the same two columns. */
  .pl-chkbx-flex {
    margin: 0px;
    > div {
      width: 48%;
    }
    /* A donation link offers only Allow Tax and Include Related Items, and
       half-width columns push them half the popup apart. They stack one per
       line instead. */
    &.pl-chkbx-stacked {
      flex-direction: column;
      align-items: flex-start;
      > div {
        width: auto;
      }
    }
  }
  /* Seller policy options. Same section rhythm as .pl-surcharge-section below,
     so the two read as a pair. */
  .pl-terms-section {
    display: flex;
    flex-direction: column;
    /* No top margin of its own. Terms now sits directly under Advanced, whose Sold By
       field already carries 50px beneath it (.sold-by-dropdown, reserving room for the
       menu it translates down by 50px). Those are siblings in a flex column, so margins
       add rather than collapse - a 40px top margin here stacked into a ~120px gap. */
    margin: 0px;
  }
  .pl-terms-row {
    display: flex;
    align-items: center;
    gap: 16px;

    & + .pl-terms-row {
      margin-top: 16px;
    }
    /* A fixed label column: without it the longer "Terms & Conditions" pushes
       its dropdown further right than "Return Policy". */
    .pl-terms-label {
      flex: 0 0 190px;
      width: 190px;
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
      color: #152837;
    }
    .purchase-link-select {
      width: 220px;
      .header {
        width: 220px;
      }
    }
  }
  /* Sits directly under the List Options checkboxes: one section gap between
     them, matching .pl-chkbx-panel above, and no padding of its own. */
  .pl-surcharge-section {
    display: flex;
    flex-direction: column;
    margin: 40px 0px 24px;
  }
  .return-days-input {
    margin-left: 0px;
    input {
      height: 26px;
      min-width: 35px;
      max-width: 55px;
      width: auto;
      padding: 2px 0px 2px 5px;
    }
  }
  .pl-last-dropdown {
    /* The Sold By field it wraps already reserves 50px below itself, so this second
       spacer only stacked on top of it. Kept as a hook rather than deleted, since the
       markup still names it. */
    margin-bottom: 0px;
  }

  .dpdn-with-icons {
    img {
      height: 20px;
      width: 20px;
    }
  }
  .pl-advance-section {
    > label {
      font-size: 18px;
      font-weight: 600;
      & + i {
        margin-top: 2px;
        margin-left: 10px;
      }
    }
  }
  .merchant-account-dropdown {
    min-width: 300px;
  }
  .sold-by-dropdown {
    min-width: 300px;
    margin: 0px 0px 50px 0px;
    .header {
      min-height: 40px;
      height: auto;
      padding: 9px 8px;
    }
    .options-menu {
      transform: translate(0px, 50px);
    }
    .logo-in-dpdn {
      height: 35px;
      width: 35px;
      border-radius: 50%;
    }
    .select-header-icon {
      transform: translate(0px, 10px);
      height: unset;
    }
    .select-header-span {
      padding: 0px;
      /* min-height:35px; */
    }
    .dropdown-option-list {
      max-height: 85px;
    }
  }
  .pl-rendered-section {
    margin-left: 50px;
  }
  .pl-navpills .nav-item {
    a {
      width: 200px;
    }
  }
  .purchase-link-select {
    .select-header-span {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .carousel-indicators {
    transform: translate(-50%, 100%) !important;
  }
  ${CustomCarouselWrapper} {
    height: 300px !important;
    /* A donation link's details column is short, so pinning the media to a
       flat 300px left a band of empty space between Link Details and List
       Options. Here the media keeps its own height and is capped instead, so
       the row is only ever as tall as the media actually is. */
    &.pl-donation-carousel {
      height: auto !important;
      .carousel-inner .carousel-item img,
      video {
        max-height: 300px;
      }
    }
  }
`;
